import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SliceKeys, Dialog } from "@sso/constant";
import { RootState } from "@sso/store";
import { DialogState } from "@sso/types";

const initialState: DialogState = {
  type: Dialog.CLOSE,
  close: false,
};

export const DialogSlice = createSlice({
  name: SliceKeys.DIALOG,
  initialState,
  reducers: {
    openDialog: (dialog: DialogState, action: PayloadAction<DialogState>) => {
      dialog.type = action.payload.type;
      dialog.data = action.payload.data;
      dialog.id = action.payload.id;
      dialog.msg = action.payload.msg;
    },
    closeDialog: (dialog: DialogState) => {
      dialog.close = true;
    },
    detachDialog: (dialog: DialogState) => {
      dialog.type = Dialog.CLOSE;
      dialog.close = false;
    },
  },
});

export const { openDialog, closeDialog, detachDialog } = DialogSlice.actions;
export const selectDialog = (state: RootState) => state.dialog;
export const selectDialogData = (state: RootState) => state.dialog.data;

export default DialogSlice.reducer;
